"use strict";

/**
 *  Load modules
 */
import common from "./modules/common";
import sliders from "./modules/sliders";
import multipleFilterProducts from "./modules/multiple-filter-products";
import Product from "./modules/Product";

// Upthrust: Sergey Loysha 22/03/2022
import Collections from "./modules/Collections";
import "../scss/app.scss";
$(document).ready(function () {
  common();
  sliders();
  multipleFilterProducts();
  Product().then(function () {
    console.log("Product module initialized");
  })["catch"](function () {
    console.log("Product module failed");
  });
  Collections();
});